import type { Device } from '@studio/models/device';
import { useSyncExternalStore } from 'react';
import { useMultiDeviceStateQuery } from '#~/statequery/hook.js';
import { locateProxy } from '#~/agent/index.js';
import { isPresetChecking, presetAccess, subscribePresetChecking } from './access.js';

// Subscribe to original status transactions, including optional capability presence.
export const usePresetAccess = (deviceId: Device['id']) => {
  const states = useMultiDeviceStateQuery({
    transform: ({ id }) => presetAccess(locateProxy(id), id)
  });
  return states[deviceId] ?? 'error';
};

// True while an operator's action waits for this camera's capabilities.
export const usePresetChecking = (deviceId: Device['id']): boolean =>
  useSyncExternalStore(subscribePresetChecking, () => isPresetChecking(deviceId));
